import React from "react";

/** Grid cell link: gradient icon badge + bold name + external-link icon. */
export default function EntityLink({ icon, text, title, onClick }) {
  const handleClick = (e) => {
    e.preventDefault();
    onClick();
  };
  return (
    <a href="#!" className="mst-link" title={title} onClick={handleClick}>
      <span className="mst-link__badge">
        <i className={icon} />
      </span>
      <span className="mst-link__text">{text}</span>
      <i className="fas fa-external-link-alt mst-link__ext" />
    </a>
  );
}

/** Icon-only row action button (edit, delete, history...). */
export function RowAction({ icon, title, onClick, danger = false, className = "" }) {
  return (
    <button
      type="button"
      className={`mst-action${danger ? " is-danger" : ""}${className ? ` ${className}` : ""}`}
      title={title}
      aria-label={title}
      onClick={onClick}
    >
      <i className={icon} />
    </button>
  );
}

/**
 * The one row action of a grid: opens the record's slider (which holds view, edit and history as tabs).
 * Grids never open the slider on a row / cell click.
 */
export function OpenAction({ onClick, title = "Open details (view, edit, history)" }) {
  // Fills its cell (mst-open-cell) so the whole cell is the click / touch target.
  return <RowAction icon="fas fa-chevron-circle-right" title={title} onClick={onClick} className="mst-action--open" />;
}

/** Props of the first grid column that holds OpenAction: <Column {...OPEN_COLUMN} cellRender={...} />. */
export const OPEN_COLUMN = {
  caption: "",
  width: 40,
  fixed: true,
  cssClass: "mst-open-cell",
  alignment: "center",
  allowSorting: false,
  allowFiltering: false,
  allowSearch: false,
  allowExporting: false,
  allowResizing: false,
};

/** Active / inactive pill. */
export function StatusPill({ active }) {
  return (
    <span className={`mst-status ${active ? "is-active" : "is-inactive"}`}>
      {active ? "Active" : "Inactive"}
    </span>
  );
}
